import { createSearchAndFilterDisplayOptions, mapSortAndFilter } from 'stores/adapters/bex-api/search/search-sort-filter-adapter';
import { SearchMigrationAdapter } from 'stores/adapters/bex-api/migration-adapters';

import { DefaultRequestFields, HotelResultsViewModel } from 'models';

import { OperationResult, PropertySearch } from '__generated__/api';

export const adaptSortAndFilters: SearchMigrationAdapter = (
  bffResults: HotelResultsViewModel,
  bexApiResults: OperationResult<PropertySearch.Query>
): HotelResultsViewModel => {
  const { data } = bexApiResults;

  if (!data.propertySearch) {
    return bffResults;
  }

  const { propertySearch } = data;

  return {
    ...bffResults,
    sortAndFilter: mapSortAndFilter(propertySearch),
    searchAndFilterDisplayOptions: createSearchAndFilterDisplayOptions(),
    defaultRequestFields: mapDefaultRequestFields(bffResults.defaultRequestFields, propertySearch.searchCriteria)
  };
};

export const mapDefaultRequestFields = (
  bffDefaultRequestFields: DefaultRequestFields,
  searchCriteria: PropertySearch.SearchCriteria
): DefaultRequestFields => {
  const defaultRequestFields: DefaultRequestFields = { ...bffDefaultRequestFields };

  if (searchCriteria.sort != null) {
    defaultRequestFields.sort = searchCriteria.sort;
  }

  if (searchCriteria.destination != null) {
    const destination = searchCriteria.destination;
    if (destination.regionId != null) {
      defaultRequestFields.regionId = destination.regionId;
    }
    if (destination.regionName != null) {
      defaultRequestFields.destination = destination.regionName;
    }
  }

  Object.keys(searchCriteria.filters).forEach(filter => {
    const filterVal = searchCriteria.filters[filter];
    if (filterVal != null && filterDict[filter] != null) {
      // temporary hack until universal sort and filter. see: https://expedia.slack.com/archives/GJY77CBQX/p1567010905012000
      if (filter === 'reviewScore') {
        defaultRequestFields[filterDict[filter]] = (filterVal.min * 10).toString();
      } else if (Array.isArray(filterVal) && filterVal.length > 0) {
        defaultRequestFields[filterDict[filter]] = filterVal.map(x => x.toString());
      } else if (typeof filterVal === 'string') {
        defaultRequestFields[filterDict[filter]] = filterVal;
      }
    }
  });

  return defaultRequestFields;
};

const filterDict = {
  sort: 'sort',
  accessibility: 'accessibility',
  amenities: 'amenities',
  bedroomFilter: 'bedroomFilter',
  deals: 'deals',
  propertyName: 'hotelName',
  propertyStyles: 'propertyStyle',
  structureTypes: 'lodging',
  paymentType: 'paymentType',
  poi: 'poi',
  priceBuckets: 'price',
  reviewScore: 'guestRating',
  starList: 'star',
  travelerType: 'travelerType'
};
